/**
 * Freebie pass upsell tracking (models/freebie-upsell-event.js).
 *
 * Put on the upsell button: ui8-upsell-track="modal|wall|page"
 * upsell-product="<product id>". Sends a "view" when the element appears and
 * whenever the placement value changes (the countdown panel turning into the
 * wall), and a "click" on click. Goes out as a beacon so the click survives
 * the navigation to the pass page.
 */
angular.module("UI8.directives").directive("ui8UpsellTrack", [
  function () {
    var URL = "/api/freebie-upsell";

    function csrfToken() {
      var meta = document.querySelector('meta[name="csrf-token"]');
      return meta ? meta.getAttribute("content") : undefined;
    }

    function send(kind, placement, product) {
      var payload = JSON.stringify({
        kind: kind,
        placement: placement,
        product: product || undefined,
        _csrf: csrfToken(),
      });
      try {
        if (
          navigator.sendBeacon &&
          navigator.sendBeacon(
            URL,
            new Blob([payload], { type: "application/json" })
          )
        )
          return;
      } catch (e) {}
      try {
        var xhr = new XMLHttpRequest();
        xhr.open("POST", URL, true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(payload);
      } catch (e) {}
    }

    return {
      restrict: "A",
      link: function (scope, elem, attrs) {
        var shown = null;

        attrs.$observe("ui8UpsellTrack", function (placement) {
          if (!placement || placement === shown) return;
          shown = placement;
          send("view", placement, attrs.upsellProduct);
        });

        elem.on("click", function () {
          send("click", shown || attrs.ui8UpsellTrack, attrs.upsellProduct);
        });

        scope.$on("$destroy", function () {
          elem.off("click");
        });
      },
    };
  },
]);
